// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3f217af5","455":"6b602fa6","977":"98da9a15"}[chunkId] + ".chunk.js";
};